import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { clientsData, clientsDataUpdate, clientsDataInsert, clientsDataDelete, dataUpload } from './clientsActions'
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";
import { ClientsResponse, ClientsResponseLength } from 'src/types/request.type';

/*type ClientsState = {
  dataClients: {
    payload: ClientsResponse[] | null,
    payload_update: ClientsResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}

const initialState: ClientsState = {
  dataClients: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  }
}
*/


type ClientsState = {
  dataClients: {
    payload: ClientsResponseLength | null,
    payload_update: ClientsResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}


const initialState: ClientsState = {
  dataClients: {
    loading: false,
    success: false,
    payload_update: null,
    payload: null,
    error: "",
  }
}




const clientsSlice = createSlice({
  name: 'clients',
  initialState: initialState,
  reducers: {

    // Обычные редьюсеры
    setClientsState(state, action: PayloadAction<ClientsResponseLength>) { //ClientsResponse[]
      state.dataClients.payload =  {} as ClientsResponseLength; //[];
      state.dataClients.payload = action.payload;
    },

    setClientUpdateState(state, action: PayloadAction<ClientsResponse>) {
      state.dataClients.payload_update = null;
      state.dataClients.payload_update = action.payload;
     // console.log(state.dataClients.payload_update)

    }

  },


  extraReducers: (builder) => {
    builder
      .addCase(clientsData.pending, (state) => {
        state.dataClients.loading = true;
        state.dataClients.error = null;
      })
      .addCase(clientsData.fulfilled, (state, action) => {
        state.dataClients.loading = false;
        clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsData.rejected, (state, action) => {
        state.dataClients.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients.error = errorText ? errorText : "";
      })


      ////
      .addCase(clientsDataUpdate.pending, (state) => {
        state.dataClients.loading = true;
        state.dataClients.error = "";
      })
      .addCase(clientsDataUpdate.fulfilled, (state, action) => {
        state.dataClients.loading = false;
        clientsSlice.caseReducers.setClientUpdateState(state, action);
      })
      .addCase(clientsDataUpdate.rejected, (state, action) => {
        state.dataClients.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients.error = errorText ? errorText : "";
      })



      ////
      .addCase(clientsDataDelete.pending, (state) => {
        state.dataClients.loading = true;
        state.dataClients.error = "";
      })
      .addCase(clientsDataDelete.fulfilled, (state, action) => {
        state.dataClients.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsDataDelete.rejected, (state, action) => {
        state.dataClients.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients.error = errorText ? errorText : "";
      })




      ////
      .addCase(clientsDataInsert.pending, (state) => {
        state.dataClients.loading = true;
        state.dataClients.error = "";
      })
      .addCase(clientsDataInsert.fulfilled, (state, action) => {
        state.dataClients.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsDataInsert.rejected, (state, action) => {
        state.dataClients.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients.error = errorText ? errorText : "";
      })


      ////
      .addCase(dataUpload.pending, (state) => {
        state.dataClients.loading = true;
        state.dataClients.error = "";
      })
      .addCase(dataUpload.fulfilled, (state, action) => {
        state.dataClients.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(dataUpload.rejected, (state, action) => {
        state.dataClients.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients.error = errorText ? errorText : "";
      })


  }

})


const getErrorText = (error: ErrorResponse) => {

 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export default clientsSlice.reducer